import React, { useState } from 'react';
import TripsHero from '../components/Trips/TripsHero';
import TripsGrid from '../components/Trips/TripsGrid';
import './TripsPage.css';

function TripsPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedDuration, setSelectedDuration] = useState('all');
  const [priceRange, setPriceRange] = useState('all');

  const categories = [
    { id: 'all', name: 'All Tours' },
    { id: 'Silver', name: 'Silver' },
    { id: 'Mid-Range', name: 'Mid-Range' },
    { id: 'Luxury', name: 'Luxury' },
    { id: 'Budget', name: 'Budget' }
  ];

  const durations = [
    { id: 'all', name: 'All Durations' },
    { id: '1-3', name: '1-3 Days' },
    { id: '4-6', name: '4-6 Days' },
    { id: '7-9', name: '7-9 Days' },
    { id: '10+', name: '10+ Days' }
  ];

  const priceRanges = [
    { id: 'all', name: 'All Prices' },
    { id: 'budget', name: 'Under $1,000' },
    { id: 'mid', name: '$1,000 - $2,500' },
    { id: 'premium', name: '$2,500 - $4,000' },
    { id: 'luxury', name: 'Over $4,000' }
  ];

  return (
    <div className="trips-page">
      <TripsHero 
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      <div className="trips-content">
        <div className="trips-filters">
          <div className="filter-group">
            <h3 className="filter-group-title">Category</h3>
            <div className="filter-buttons">
              {categories.map((category) => (
                <button
                  key={category.id}
                  className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category.id)}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>

          <div className="filter-group">
            <h3 className="filter-group-title">Duration</h3>
            <div className="filter-buttons">
              {durations.map((duration) => (
                <button
                  key={duration.id}
                  className={`filter-btn ${selectedDuration === duration.id ? 'active' : ''}`}
                  onClick={() => setSelectedDuration(duration.id)}
                >
                  {duration.name}
                </button>
              ))}
            </div>
          </div>

          <div className="filter-group">
            <h3 className="filter-group-title">Price Range</h3>
            <div className="filter-buttons">
              {priceRanges.map((range) => (
                <button
                  key={range.id}
                  className={`filter-btn ${priceRange === range.id ? 'active' : ''}`}
                  onClick={() => setPriceRange(range.id)}
                >
                  {range.name}
                </button>
              ))}
            </div>
          </div>
        </div>

        <TripsGrid 
          searchQuery={searchQuery}
          selectedCategory={selectedCategory}
          selectedDuration={selectedDuration}
          priceRange={priceRange}
        />
      </div>
    </div>
  );
}

export default TripsPage;

